import React from "react";

import { Typography, IconButton, Grid } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

import MonthYearLabel from "components/libComponents/MonthYearLabel";
import { useFilter } from "libLegacy/hooks/dashboard";
import {
  ALGA_SUCCESS,
  ALGA_ERROR,
  ALGA_INFO,
} from "components/libComponents/AlgaTooltips/AlgaIcon";
import AlgaTooltip from "components/libComponents/AlgaTooltips";
import ApprovalDetailsList from "components/libComponents/ApprovalDetailsList";

const useStyles = makeStyles()((theme) => ({
  header: {
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(4, 2),
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  content: {
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
  },
}));

const ALGA_TEXTS = {
  [ALGA_SUCCESS]: "Sua fatura está correta!",
  [ALGA_ERROR]: "Há inconsistências na fatura!",
  [ALGA_INFO]: "Sua fatura está em análise.",
};

export const InvoiceApproval = ({ history }) => {
  const invoiceData = history.location.state.data;
  const [{ month, year }] = useFilter();

  const { classes } = useStyles();

  const status = invoiceData.status;
  const variant =
    status === "CONSISTENT"
      ? ALGA_SUCCESS
      : status === "INCONSISTENT"
      ? ALGA_ERROR
      : ALGA_INFO;

  const handleClick = () => {
    history.goBack();
  };

  return (
    <>
      <Grid container className={classes.header}>
        <Grid item className={classes.headerTitle}>
          <IconButton edge="start" size="medium" onClick={handleClick}>
            <ChevronLeft />
          </IconButton>
          {month && year && <MonthYearLabel month={month} year={year} />}
        </Grid>
        <Typography variant="body1" paragraph>
          Veja aqui a análise da sua fatura em detalhes:
        </Typography>
        <AlgaTooltip variant={variant} text={ALGA_TEXTS[variant]} />

        {/* TODO: show button when the download option is implemented
        <Button variant="outlined" color="primary" fullWidth>
          Download da homologação
        </Button> */}
      </Grid>

      {invoiceData.alerts.length > 0 && (
        <Grid className={classes.content}>
          <ApprovalDetailsList variant="info" alerts={invoiceData.alerts} />
        </Grid>
      )}

      {invoiceData.inconsistencies.length > 0 && (
        <Grid className={classes.content}>
          <ApprovalDetailsList
            variant="error"
            alerts={invoiceData.inconsistencies}
          />
        </Grid>
      )}

      {invoiceData.validated.length > 0 && (
        <Grid className={classes.content}>
          <ApprovalDetailsList
            variant="success"
            alerts={invoiceData.validated}
          />
        </Grid>
      )}
    </>
  );
};
